import {createNavigation} from 'next-intl/navigation';
import {defineRouting} from 'next-intl/routing';
import {getContentfulEnvironment} from "@/libs/helper/helper";

export const contentfulLanguages = new Set(['en', 'de-DE', 'de-AT'])
export const allowedLanguagesForHreflang = ['en', 'de-DE', 'de-AT']
export const fallBackLanguage = 'en';

export const routing = defineRouting({
    locales: ["de-DE", "de-AT", "de-CH", "en", "nl-NL", "nl-BE", "it-IT", "fr-FR", "fr-CH", "no-NO", "sv-SE", "cs-CZ", "fr-BE"],
    defaultLocale: 'en',
    localePrefix: getContentfulEnvironment() === 'master' ? 'never' : 'as-needed',
    localeDetection: false,
    localeCookie: false,
    alternateLinks: false,
    pathnames: {
        '/': '/',
        '/newsroom/news': '/newsroom/news',
        '/newsroom/news/[slug]': '/newsroom/news/[slug]',
    },
    // @ts-ignore
    domains: getDomains()
});


export function getDomains() {
    const contentfulEnvironment = getContentfulEnvironment();

    switch (contentfulEnvironment) {
        case 'develop':
            return [
                {
                    domain: 'de.bonprixdev',
                    defaultLocale: 'de-DE',
                    locales: ['de-DE']
                },
                {
                    domain: 'at.bonprixdev',
                    defaultLocale: 'de-AT',
                    locales: ['de-AT']
                },
                {
                    domain: 'en.bonprixdev',
                    defaultLocale: 'en',
                    locales: ['en']
                },
                {
                    domain: 'it.bonprixdev',
                    defaultLocale: 'it',
                    locales: ['it']
                }
            ]
        case 'stage':
            return [
                {
                    domain: 'de.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-DE',
                    locales: ['de-DE']
                },
                {
                    domain: 'at.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-AT',
                    locales: ['de-AT']
                },
                {
                    domain: 'de-de.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-DE',
                    locales: ['de-DE']
                },
                {
                    domain: 'de-at.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-AT',
                    locales: ['de-AT']
                },
                {
                    domain: 'en.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'en',
                    locales: ['en']
                },
                {
                    domain: 'fr-fr.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-FR',
                    locales: ['fr-FR']
                },
                {
                    domain: 'it-it.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'it-IT',
                    locales: ['it-IT']
                },
                {
                    domain: 'nl-nl.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'nl-NL',
                    locales: ['nl-NL']
                },
                {
                    domain: 'no-no.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'no-NO',
                    locales: ['no-NO']
                },
                {
                    domain: 'sv-se.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'sv-SE',
                    locales: ['sv-SE']
                },
                {
                    domain: 'fr-ch.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-CH',
                    locales: ['fr-CH']
                },
                {
                    domain: 'cs-cz.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'cs-CZ',
                    locales: ['cs-CZ']
                },
                {
                    domain: 'de-ch.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-CH',
                    locales: ['de-CH']
                },
                {
                    domain: 'fr-be.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-BE',
                    locales: ['fr-BE']
                },
                {
                    domain: 'nl-be.dev-corporate-service.acns.bonprix.net',
                    defaultLocale: 'nl-BE',
                    locales: ['nl-BE']
                }
            ]
        default:
            return [
                {
                    domain: 'de-de.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-DE',
                    locales: ['de-DE']
                },
                {
                    domain: 'de-at.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-AT',
                    locales: ['de-AT']
                },
                {
                    domain: 'en.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'en',
                    locales: ['en']
                },
                {
                    domain: 'fr-fr.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-FR',
                    locales: ['fr-FR']
                },
                {
                    domain: 'it-it.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'it-IT',
                    locales: ['it-IT']
                },
                {
                    domain: 'nl-nl.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'nl-NL',
                    locales: ['nl-NL']
                },
                {
                    domain: 'no-no.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'no-NO',
                    locales: ['no-NO']
                },
                {
                    domain: 'sv-se.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'sv-SE',
                    locales: ['sv-SE']
                },
                {
                    domain: 'fr-ch.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-CH',
                    locales: ['fr-CH']
                },
                {
                    domain: 'cs-cz.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'cs-CZ',
                    locales: ['cs-CZ']
                },
                {
                    domain: 'de-ch.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'de-CH',
                    locales: ['de-CH']
                },
                {
                    domain: 'fr-be.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'fr-BE',
                    locales: ['fr-BE']
                },
                {
                    domain: 'nl-be.prd-corporate-service.acns.bonprix.net',
                    defaultLocale: 'nl-BE',
                    locales: ['nl-BE']
                }
            ]
    }
}

export const {Link, useRouter} =
    createNavigation(routing);